<template>
   <v-container fluid class="d-flex justify-center align-center backgroundW"
      style="height: 100vh;position: fixed; top: 0;left:0; width:100vw ; z-index: 1000;">

      <div>
         <AnimatedLogo height="100px" classes="justify-center d-flex" />
         <img src="@/assets/img/png/files/loading.gif" class="mt-5" :height="60" alt="">
      </div>

   </v-container>
</template>
<style  scoped>
</style>


<script>
import AnimatedLogo from './AnimatedLogo.vue';

export default {
   name: "SplashLoader",
   computed: {

   },
   components: { AnimatedLogo },
   data: () => ({

   }),
   mounted() {

   },

   methods: {

   },
};
</script>
